/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * ChangHeon Yoo (chyoo@rsupport.com)
 *
 * @description
 *
 * @created at Mon Apr 22 2024
 **/

import { Chip as DesignStuffChip, IconComponentProps } from "@/frameworks/designStuff/components";

import { usePersistUser } from "@/frameworks/core/persistence";

export default function UserChip({
	userID,
	isValid,
	isError,
	handleClose,
	icon,
	isEllipsisText
}: {
	userID: string;
	isValid: boolean;
	isError?: boolean;
	handleClose?: ((ev?: React.MouseEvent<SVGSVGElement, MouseEvent> | undefined) => void) | undefined;
	icon?: IconComponentProps;
	isEllipsisText?: boolean;
}) {
	const user = usePersistUser(userID);
	return (
		<DesignStuffChip
			src={user?.profileImagePath}
			colorTheme={isValid ? "blue" : isError ? "red" : "orange"}
			isError={isError}
			handleClose={handleClose}
			icon={icon}
			isEllipsisText={isEllipsisText}
		>
			{user?.name || userID}
		</DesignStuffChip>
	);
}
